export const FAMILY_RICHIESTA_CATEGORIE = [
  ["assistenza", "Assistenza"],
  ["farmaci_ricette", "Farmaci e ricette"],
  ["amministrazione", "Amministrazione"],
  ["documenti", "Documenti"],
  ["appuntamenti", "Appuntamenti"],
  ["altro", "Altro"],
];

export const FAMILY_RICHIESTA_STATI = [
  ["nuova", "Nuova", "bg-rose-500", "text-rose-700"],
  ["presa_in_carico", "Presa in carico", "bg-amber-400", "text-amber-800"],
  ["risposta_inviata", "Risposta inviata", "bg-[#6e48b5]", "text-[#5a3b94]"],
  ["chiusa", "Chiusa", "bg-emerald-500", "text-emerald-800"],
];

export function familyRichiestaCategoria(value) {
  return FAMILY_RICHIESTA_CATEGORIE.find(([key]) => key === value)?.[1] || (value || "").replaceAll("_", " ");
}

export function familyRichiestaStato(value) {
  return FAMILY_RICHIESTA_STATI.find(([key]) => key === value) || FAMILY_RICHIESTA_STATI[0];
}

export function familyRichiestaCodice(item) {
  const codice = (item?.codice || "").replace(/^#/, "");
  if (codice) return `#${codice}`;
  const short = String(item?.id || "").slice(0, 4).toUpperCase();
  return short ? `#FAM-${short}` : "#FAM";
}

export function familyRichiestaDate(value) {
  if (!value) return "";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "";
  return date.toLocaleDateString("it-IT", { day: "2-digit", month: "2-digit", year: "numeric" });
}

export function familyRichiestaWhen(value) {
  if (!value) return "";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "";
  return date.toLocaleString("it-IT", { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" });
}
